import { render, staticRenderFns } from "./CampaignStatisticsWidgetsComponent.vue?vue&type=template&id=f8d75fbc&"
import script from "./CampaignStatisticsWidgetsComponent.vue?vue&type=script&lang=js&"
export * from "./CampaignStatisticsWidgetsComponent.vue?vue&type=script&lang=js&"
import style0 from "./CampaignStatisticsWidgetsComponent.vue?vue&type=style&index=0&id=f8d75fbc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports